import { formatDate } from 'commons/utils/date'
import { type HeadItemType, Table } from 'components/Table'
import type { EdiUploadError, FranchiseUploadError } from 'services/batchOrder/interfaces'

import * as S from './styles'

const headDataEdi: HeadItemType[] = [
  { columnName: 'nr_linh', label: 'Número da coluna' },
  { columnName: 'ds_msg', label: 'Descrição de erro' },
]

const headDataFranchises: HeadItemType[] = [
  { columnName: 'TipoOV', label: 'Tipo OV' },
  { columnName: 'Quebra', label: 'Quebra' },
  { columnName: 'DataPrevistaFaturamento', label: 'Prev. Faturam.' },
  { columnName: 'Centro', label: 'Fábrica' },
  { columnName: 'CondicaoPagamento', label: 'Cond. Pagam.' },
  { columnName: 'Cliente', label: 'Cliente' },
  { columnName: 'Material', label: 'Material' },
  { columnName: 'Tamanho', label: 'Tamanho' },
  { columnName: 'Cor', label: 'Cor' },
  { columnName: 'ErrorMenssage', label: 'Erro' },
]

interface UploadSpreadsheetTableErrorProps {
  data: EdiUploadError[] | FranchiseUploadError[]
}

const UploadSpreadsheetTableError: React.FC<UploadSpreadsheetTableErrorProps> = ({ data }) => {
  const isEdiError = (item: EdiUploadError | FranchiseUploadError): item is EdiUploadError => {
    return (item as EdiUploadError).nr_linh !== undefined
  }

  const renderSummary = () => {
    const amount = data?.length ?? 0
    return amount > 1 ? `${amount} erros encontrados` : `${amount} erro encontrado`
  }

  const renderBody = () => {
    return data.map((item) => {
      if (isEdiError(item)) {
        const key = `${item.nr_linh}-${item.ds_msgm}`

        return {
          content: [
            <S.DataWrap key={`colNumber-${key}`}>
              <span>{item.nr_linh}</span>
            </S.DataWrap>,
            <S.DataWrap key={`ErrorDescription-${key}`}>
              <span>{item.ds_msgm}</span>
            </S.DataWrap>,
          ],
          id: `id-${key}`,
        }
      }

      const key = `${item.TipoOV}-${item.Quebra}-${item.DataPrevistaFaturamento}-${item.ErrorMenssage}`

      return {
        content: [
          <S.DataWrap key={`TipoOV-${key}`}>
            <span>{item.TipoOV}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Quebra-${key}`}>
            <span>{item.Quebra}</span>
          </S.DataWrap>,
          <S.DataWrap key={`DataPrevistaFaturamento-${key}`}>
            <span>{formatDate(item.DataPrevistaFaturamento)}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Centro-${key}`}>
            <span>{item.Centro}</span>
          </S.DataWrap>,
          <S.DataWrap key={`CondicaoPagamento-${key}`}>
            <span>{item.CondicaoPagamento}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Cliente-${key}`}>
            <span>{item.Cliente}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Material-${key}`}>
            <span>{item.Material ?? '-'}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Tamanho-${key}`}>
            <span>{item.Tamanho ?? '-'}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Cor-${key}`}>
            <span>{item.Cor ?? '-'}</span>
          </S.DataWrap>,
          <S.DataWrap key={`ErrorMenssage-${key}`}>
            <span>{item.ErrorMenssage}</span>
          </S.DataWrap>,
        ],
        id: `id-${key}`,
      }
    })
  }

  const headData = data.length > 0 && isEdiError(data[0]) ? headDataEdi : headDataFranchises

  return (
    <S.Container>
      <S.Summary>{renderSummary()}</S.Summary>
      <Table bodyData={renderBody()} distributeWidth={false} headData={headData} rowHeight={40} />
    </S.Container>
  )
}

export default UploadSpreadsheetTableError
